import api from '../../utils/api';
import { alertError, alertSuccess } from './alert';
import { getSupplierWarehouses } from './api/suppliers';
import {
  WAREHOUSE,
  WAREHOUSES,
  WAREHOUSES_LOADING,
  WAREHOUSE_LOADING,
  WAREHOUSE_SUBMITTING,
} from '../constants/warehousesTypes';

export const setWarehouse = (data) => ({ type: WAREHOUSE, payload: data });
const setWarehouseLoading = (value) => ({ type: WAREHOUSE_LOADING, payload: value });
const setWarehouseSubmitting = (value = true) => ({ type: WAREHOUSE_SUBMITTING, payload: value });

export const setWarehouses = (data) => ({ type: WAREHOUSES, payload: data });
const setWarehousesLoading = (value) => ({ type: WAREHOUSES_LOADING, payload: value });

export const getWarehouses =
  (showLoading = true) =>
  async (dispatch, getState) => {
    const { supplierId } = getState().role;

    try {
      if (showLoading) {
        dispatch(setWarehousesLoading(true));
      }

      const response = await getSupplierWarehouses(supplierId);
      dispatch(setWarehouses(response.data));
    } catch (error) {
      dispatch(alertError(error));
    } finally {
      if (showLoading) {
        dispatch(setWarehousesLoading(false));
      }
    }
  };

export const getWarehouse = (warehouseId) => async (dispatch) => {
  dispatch(setWarehouseLoading(true));

  try {
    const response = await api.get(`/warehouses/${warehouseId}`);
    dispatch(setWarehouse(response.data));
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setWarehouseLoading(false));
  }
};

export const putWarehouse = (warehouseId, data) => async (dispatch, getState) => {
  const { supplierId } = getState().role;
  dispatch(setWarehouseSubmitting());

  try {
    const response = await putSupplierWarehouse(supplierId, warehouseId, data);

    if (response.data) {
      if (data.priority) {
        dispatch(alertSuccess(`Warehouse #${warehouseId} priority was updated`));
      } else {
        data.is_enabled
          ? dispatch(alertSuccess(`Warehouse #${warehouseId} was activated`))
          : dispatch(alertSuccess(`Warehouse #${warehouseId} was deactivated`));
      }
    } else {
      if (data.is_enabled) {
        dispatch(alertError(`Warehouse #${warehouseId} activation update failed`));
      } else {
        data.priority
          ? dispatch(alertError(`Warehouse #${warehouseId} priority update failed`))
          : dispatch(alertError(`Error updating warehouse #${warehouseId}`));
      }
    }

    dispatch(getWarehouses(false));
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setWarehouseSubmitting(false));
  }
};

export const putNetSuiteWarehouse = (warehouseId, data) => async (dispatch, getState) => {
  const { supplierId } = getState().role;
  dispatch(setWarehouseSubmitting());

  try {
    const response = await putSupplierWarehouse(supplierId, warehouseId, data);
    if (response?.status === 200) {
      dispatch(alertSuccess('Successfully updated warehouse'));
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setWarehouseSubmitting(false));
  }
};

let cancelPutSupplierWarehouse;
function putSupplierWarehouse(supplierId, warehouseId, data) {
  if (cancelPutSupplierWarehouse) {
    cancelPutSupplierWarehouse('Cancel put warehouse');
  }

  return api.put(`/suppliers/${supplierId}/warehouses/${warehouseId}`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutSupplierWarehouse = c)),
  });
}

export const postWarehouse = (data) => async (dispatch, getState) => {
  const { supplierId } = getState().role;
  dispatch(setWarehouseSubmitting());

  try {
    const response = await api.post(`/suppliers/${supplierId}/warehouses`, data);
    if (response?.data) {
      dispatch(alertSuccess('Successfully created a new warehouse'));
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setWarehouseSubmitting(false));
  }
};
